import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { useAuth } from '../hooks/useAuth';
import { apiService } from '../services/api';

export function Setup2FA() {
  const [qrCode, setQrCode] = useState('');
  const [secret, setSecret] = useState('');
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { refreshUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    apiService.getTwoFactorSetup()
      .then((data) => {
        setQrCode(data.qrCode);
        setSecret(data.secret);
      })
      .catch(() => setError('Failed to load 2FA setup'));
  }, []);

  const handleEnable = async () => {
    if (!token) return;
    setLoading(true);
    setError('');
    try {
      await apiService.enableTwoFactor(token);
      await refreshUser();
      navigate('/payments');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Invalid code, please try again');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Set Up Two-Factor Authentication</CardTitle>
          <CardDescription>
            Two-factor authentication is required. Scan the QR code with your authenticator app, then enter the 6-digit code to confirm.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          {qrCode && (
            <div className="flex justify-center">
              <img src={qrCode} alt="2FA QR Code" className="w-48 h-48" />
            </div>
          )}

          {secret && (
            <div className="space-y-1">
              <p className="text-sm text-muted-foreground">Can't scan? Enter this key manually:</p>
              <p className="font-mono bg-muted px-3 py-2 rounded whitespace-nowrap" style={{ fontSize: 'clamp(0.5rem, 1.8vw, 0.75rem)' }}>{secret}</p>
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor="token">Verification Code</Label>
            <Input
              id="token"
              type="text"
              maxLength={6}
              placeholder="000000"
              value={token}
              onChange={(e) => setToken(e.target.value.replace(/\D/g, ''))}
            />
          </div>

          {error && <p className="text-sm text-red-600">{error}</p>}

          <Button className="w-full" onClick={handleEnable} disabled={token.length !== 6 || loading}>
            {loading ? 'Verifying...' : 'Activate & Continue'}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
